import {getDataItem} from '@/helpers/kendo-helpers'
import {jsonDropDownEditor, readOnlyEditor} from '@/helpers/kendo-editors'

const isBuyingEditor = function(container, options) {
  let textField = 'buySell',
    valueField = 'isBuying',
    defaultOptions = {
      template: '<span>${' + textField + '}</span>',
      change: function(e) {
        var text = e.sender.text(),
          childItem = getDataItem(e.sender.element)

        childItem.set(textField, text)
        childItem.set('buySell2', e.sender.text() === 'Buy' ? 'Sell' : 'Buy')
      },
      dataSource: [{buySell: 'Buy', isBuying: true}, {buySell: 'Sell', isBuying: false}],
    }

  var input =
    '<input id="' +
    options.field +
    '"  name="' +
    options.field +
    '" data-text-field="' +
    textField +
    '" data-value-field="' +
    valueField +
    '" data-bind="value:' +
    options.field +
    '"/>'

  kendo
    .jQuery(input)
    .appendTo(container)
    .kendoDropDownList(defaultOptions)
}

const baseCcyEditor = function(clientId, marketId, change = () => {}) {
  return function(container, options) {
    var rowIndex = kendo.jQuery('tr[data-uid=' + options.model.uid + ']').index()
    if (options.model.CcyPairId && rowIndex > 0) {
      return readOnlyEditor.apply(this, arguments)
    }

    return jsonDropDownEditor(
      'baseCcy',
      'baseCcy',
      '/api/list/deal/getAllCurrencies?clientId=' + clientId + '&marketId=' + marketId,
      {
        dataBound: function() {
          var ds = this.dataSource,
            filter = ds.filter()
          if (filter != null && filter.filters.length > 0) return

          const foreignCcy = options.model.foreignCcy || options.model.ccy1
          ds.filter([{field: 'foreignCcy', operator: 'eq', value: foreignCcy}])
        },
        change: function(e) {
          var ccyItem = e.sender.dataItem(),
            dataItem = getDataItem(e.sender.element)
          if (dataItem == null || ccyItem == null) return

          dataItem.set('ccyPairId', ccyItem.ccyPairId)
          dataItem.set('ccyDividing', ccyItem.isDividing)

          change(dataItem, e)
        },
      },
      false,
    ).call(this, container, options)
  }
}

export {isBuyingEditor, baseCcyEditor}
